<!--
 * @Autor: GeekMzy
 * @Date: 2022-04-18 10:34:28
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2024-04-29 15:10:02
 * @FilePath: \htwlgs-drainage-webv2-shiju\src\views\Main.vue
 * @Author: desktop-1llkr2o
-->
<template>
  <Map />
  <ht-header />
  <div class="main_content">
    <!-- 音视频 通话模块 -->
    <div class="mid">
      <RouterView></RouterView>
    </div>
    <VideoInfo ref="videoInfo" :visible="isShowCall" :xh-data="xhData" @hideCall="hideCall" />
  </div>
  <MapLegend style="right: 420px"></MapLegend>
  <MapTools style="right: 620px"></MapTools>
  <LayersManage v-show="mainStore.customer"></LayersManage>
  <Dialog></Dialog>
  <Dialog2></Dialog2>
</template>

<script setup lang="ts">
import Map from '@/components/map/Map.vue'
// import Dialog from '@/components/Dialog.vue'
import Dialog from '@/components/Dialog/Dialog.vue'
import Dialog2 from '@/components/Dialog/Dialog2.vue'
import LayersManage from '@/components/map/LayersManage.vue'
import HtHeader from '@/components/HtHeader.vue'

import VideoInfo from '@/components/map/VideoInfo.vue'
import mapService from '@/utils/mapServices'
import MapTools from '@/components/map/MapTools.vue'
import MapLegend from '@/components/map/MapLegend.vue'
import Bus from '@/config/Bus'
import { NButton } from 'naive-ui'
import { ref, reactive, nextTick, onMounted } from 'vue'
import { useMainStore } from '@/store/main'
import pinia from '@/store/index'
import { useMessage } from 'naive-ui'



window.$message2 = useMessage()

const mainStore = useMainStore(pinia)
const xhData = ref({
  lxhd: '',
  userName: '',
  lxdh: '',
})
const isShowCall = ref(false)
const videoPopShow = ref(false)
const videoInfo = ref()

const showCall = (data) => {
  xhData.value = data
  isShowCall.value = true
  videoPopShow.value = false
  nextTick(() => {
    videoInfo.value.calluser()
  })
}

const hideCall = () => {
  isShowCall.value = false
}

onMounted(() => {
  Bus.on('showCall', (data) => {
    showCall(data)
  })
  mapService.on('zjClick', (data) => {
    if (mainStore.currentLeftMenu === 'river_cheif_state') {
      Bus.emit('showModal', {
        data: {
          zj: data,
        },
        modalType: '分布统计',
      })
    }
  })
})
</script>

<style lang="scss" scoped>
.main_content {
  // z-index: 99;
  position: relative;
  display: flex;
  flex-direction: row;
  // pointer-events: none;
  height: 960px;

  .left {}

  .mid {
    flex: 1;
  }

  .right {
    position: relative;
    pointer-events: auto;
  }
}


.n-message-container .n-message-wrapper .n-message {
  background-color: #ffffff !important;
  color: #323232;
}

.n-layout-header,
.n-layout-footer {
  background: rgba(128, 128, 128, 0.2);
  padding: 24px;
}

.n-layout-sider {
  background: rgba(128, 128, 128, 0.3);
}

.n-layout-content {
  background: rgba(128, 128, 128, 0.4);
}

.n-layout-header {
  padding: 10px 24px;
}

.mapboxgl-ctrl-logo {
  display: none !important;
}

/* 日历样式 和下拉框样式*/

:deep(.el-popper[data-popper-placement^='bottom'] > .el-popper__arrow::before) {
  background: #2990ca;
}

:deep(.el-popper[data-popper-placement^='left'] > .el-popper__arrow::before) {
  background: #2990ca;
}

:deep(.el-popper.is-light) {
  background: #2990ca;
  z-index: 1122;
}

:deep(.el-picker-panel) {
  background: #2990ca;
}

:deep(.el-date-editor .el-range__icon) {
  color: white;
}

:deep(.el-date-editor .el-range-separator) {
  color: white;
}

:deep(.el-date-editor .el-range-input) {
  color: white;
}

:deep(.el-date-picker__header-label) {
  color: white;
}

:deep(.el-month-table td .cell) {
  color: white;
}

:deep(.el-year-table td .cell) {
  color: white;
}

:deep(.el-date-table td .el-date-table-cell .el-date-table-cell__text) {
  color: white;
}

:deep(.el-date-table th) {
  color: white;
}

:deep(.el-select-dropdown__item) {
  color: white;
}

:deep(.el-select-dropdown__item.hover, .el-select-dropdown__item:hover) {
  background: #a4ffff;
  color: #666;
}

:deep(.el-input__wrapper) {
  padding-left: 4px;
  padding-right: 4px;
  background: #2990ca;
}

:deep(.el-input__inner) {
  color: white;
  height: 18px;
  font-size: 12px;
}
</style>
